


























import { Component, Vue } from "vue-property-decorator";
import { Praise, Readpraise } from "@/req/user";
@Component
export default class Logout extends Vue {
  public praiseData: any = []; // 点赞内容
  public page = 1; // 点赞初始页
  public pageSize = 10;
  public isLoading = false;
  public getScroll(event) {
    const scrollBottom =
      event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight <=
      50;
    if (scrollBottom && this.isLoading == false) {
      this.isLoading = true;
      this.page++;
      this.messPraise();
    }
  }

  public show() {
    this.page = 1;
    this.praiseData = [];
    this.messPraise();
  }
  // 点赞
  public async messPraise() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      page: this.page,
    };
    const res = await Praise(obj);
    if (this.page === 1) {
      this.praiseData = res.data.praiseData.data;
      if (this.page === res.data.praiseData.last_page) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    } else {
      this.praiseData = [...this.praiseData, ...res.data.praiseData.data];
      if (this.page === res.data.praiseData.last_page) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    }
  }
  // 点赞状态更改
  public async skipPraise(boxId, praId, uId, index, read) {
    if (read) return;
    const obj = {
      token: this.$fn.cookies.getToken(),
      praise_id: praId,
      uid: uId,
    };
    const res = await Readpraise(obj);
    if (res.code == 200) {
      this.praiseData[index].is_read = 1;
      this.$router.push({ path: "/myGame/gameDetail", query: { id: boxId, comment: '2' } });
    }
  }
}
